import { Route, Switch } from "react-router-dom";
import {
  getIntegrationBuilderSelectiveSyncFilterBuilder,
  getIntegrationBuilderSelectiveSyncFilterBuilderCreate,
  getIntegrationBuilderSelectiveSyncFilterBuilderForId,
} from "../../../../router/RouterUtils";
import SelectiveSyncFilterBuilderContextProvider from "../context/SelectiveSyncFilterBuilderContextProvider";
import SelectiveSyncFiltersTableContainer from "./selective-sync-filter-table/SelectiveSyncFiltersTableContainer";
import SelectiveSyncFilterSchemaForm from "./selective-sync-schema-form/SelectiveSyncFilterSchemaForm";
import SelectiveSyncFilterSchemaFormRoot from "./selective-sync-schema-form/SelectiveSyncFilterSchemaFormRoot";

interface Props {
  integrationID: string;
}

const SelectiveSyncFilters = ({ integrationID }: Props) => {
  return (
    <SelectiveSyncFilterBuilderContextProvider integrationID={integrationID}>
      <>
        <Switch>
          <Route
            exact
            path={getIntegrationBuilderSelectiveSyncFilterBuilder(integrationID)}
            render={() => <SelectiveSyncFiltersTableContainer integrationID={integrationID} />}
          />
          <Route
            exact
            path={getIntegrationBuilderSelectiveSyncFilterBuilderForId(integrationID)}
            render={() => <SelectiveSyncFilterSchemaFormRoot integrationID={integrationID} />}
          />
          <Route
            exact
            path={getIntegrationBuilderSelectiveSyncFilterBuilderCreate(integrationID)}
            render={() => (
              <SelectiveSyncFilterSchemaForm
                selectiveSyncFilterSchemaData={null}
                integrationID={integrationID}
              />
            )}
          />
        </Switch>
      </>
    </SelectiveSyncFilterBuilderContextProvider>
  );
};

export default SelectiveSyncFilters;
